// import { observable } from "mobx";

export class StakeButtonsStatusesModel {
    plusEnabled: boolean;
    minusEnabled: boolean;

    constructor(source: StakeButtonsStatusesModel) {
        this.plusEnabled = source.plusEnabled;
        this.minusEnabled = source.minusEnabled;
    }
}